var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #010101;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M1007.94,178.11H72.04l467.96,389.96,467.94-389.96Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M565.73,651.3c-7.44,6.23-16.59,9.33-25.73,9.33s-18.3-3.1-25.73-9.33L17.27,237.16v624.52c0,22.2,18.01,40.21,40.21,40.21h965.04c22.2,0,40.21-18.01,40.21-40.21V237.16l-496.99,414.14h0Z","key":2})]);
}

Email.defaultProps = {"id":"ICONS","viewBox":"0 0 1080 1080"};

module.exports = Email;

Email.default = Email;
